import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Usuario } from '../../models/usuario';
import { environment as env } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<Usuario>;
  private readonly PATH: string = '/login';
  constructor(
    private http: HttpClient,
    private router: Router) {
    this.currentUserSubject = new BehaviorSubject<Usuario>(
      JSON.parse(localStorage.getItem('currentUser')!)
    );
    this.currentUser = this.currentUserSubject.asObservable();
    //console.log/this.currentUser);
  }
  public get currentUserValue(): Usuario {
    return this.currentUserSubject.value;
  }

  login(usuario: Usuario): Observable<any> {
    //console.log/usuario);
    return this.http
      .post(env.baseurl + this.PATH, usuario)
      .pipe(
        map((user: any) => {
          if (user != null) {
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user as Usuario);
            window.location.reload();
            return user;
          }
        })
      );
  }
  getAuthorizationToken() {
    const login = localStorage.getItem('currentUser');
    return login;
  }
  getById(id: number): Observable<any> {
    return this.http.get(env.baseurl + this.PATH + id).pipe(
      map((user: any) => {
        if (user == null) {
          Swal.fire(
            'Atenção',
            'O usuário ou senha estão erradas. Tente novamente.',
            'error'
          );
        } else {
          return user;
        }
      })
    );
  }
  logout(): void {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this.router.navigate(['/login']);
  }
}
